<template>
	<div class="container">
		<triangle-image
			title="Le domande frequenti"
			subtitle="Qui trovi le risposte a tutti i tuoi dubbi sul nostro servizio"
			:class="{'partner-bennet': $root.source === 'bennet'}"
			v-show="!giftCardPage"
			>		
		</triangle-image>

		<div>
			<section class="content faq">
				<div class="faq-categories float" :class="{'scrolled-down': scrollDown}" :style="giftCardPage && $mq.isDesktop() ? 'display: none' : ''">
					<div v-for="(content, categoryName) in (faqSource)" v-html="categoryName" @click="selectCategory(categoryName)" class="faq-category" :key="categoryName"></div>
				</div>

				<transition name="slide-right">
					<div class="faq-items" v-if="active" :class="{'scrolled-down': scrollDown, 'gift-faq-items' : giftCardPage}">
						<div :id="categoryName" class="faq-group" v-for="(content, categoryName) in (faqSource)" v-if="isCategorySelected(categoryName)" :key="categoryName">
							<div class="faq-title flex-vcenter">
								<span v-if="!$mq.isDesktop()" @click="selectedCategory = null" class="close">x</span>
								<h2 v-html="categoryName" :style="giftCardPage && $mq.isDesktop() ? 'display: none' : ''"></h2>
							</div>

							<!-- <div v-for="(answer, question) in content" class="faq-content" :key="question" :class="{'tag-partner': tagPartner.indexOf(question) >= 0}">
								<div class="faq-trigger faq-content" @click="openSection(question)" v-html="question" :class="{'rotated': !section[question]}"></div>

								<div class="faq-content" v-if="section[question] || !$mq.isDesktop()">
									<p v-html="answer"></p>
								</div>

							</div> -->
							<v-expansion-panels accordion>
								<v-expansion-panel
									v-for="(answer, question) in content"
									:key="question" 
									class="my-1" 			
									:class="{'tag-partner': tagPartner.indexOf(question) >= 0}"						
								>
									<v-expansion-panel-header style="background: lightgrey" :class="{'text-body-small': !$mq.isDesktop()}">
										{{question}}
									</v-expansion-panel-header>
									<v-expansion-panel-content v-html="answer">									
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
					</div>
				</transition>
			</section>
		</div>
	</div>
</template>

<script>
import TriangleImage from './TriangleImage'
import { scrollToElementId } from '../assets/js/main'
import FAQ from '../data/faq.json'
import FAQPARTNER from '../data/faqPartner.json'
import FAQGIFTCARD from '../data/faqGiftCard.json'

export default {
	components: {
		'triangle-image': TriangleImage
	},

	props: {
		giftCardPage: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			faq: FAQ,
			faqPartner: FAQPARTNER,
			faqGiftCard: FAQGIFTCARD,
			section: {},
			scrollDown: false,
			selectedCategory: null,
			tagPartner: [
				"Posso attivare gli ordini ricorrenti automatici?",
				"Cosa succede se una settimana non scelgo le ricette?",
				"Come faccio a cambiare il mio piano abbonamento?",
				"Posso pagare con buoni pasto Ticket Restaurant® ?",
				"Come posso pagare con i Ticket Restaurant®?"
			],
		}
	},

	watch: {
		'isDesktop' () {
			if (this.isDesktop) this.selectedCategory = null
		}
	},

	computed: {
		isDesktop () {
			return this.$mq.isDesktop()
		},

		active () {
			return this.$mq.isDesktop() || this.selectedCategory
		},

		faqSource() {
			if(this.$root.source === 'bennet') return this.faqPartner
			if(this.giftCardPage) return this.faqGiftCard
			return this.faq
		}
	},

	methods: {
		isCategorySelected (categoryName) {
			if (!this.selectedCategory) return true
			return this.selectedCategory === categoryName
		},

		openSection (question) {
			this.$set(this.section, question, !this.section[question])
		},

		selectCategory (elem) {
			if (!elem) return
			if (this.$mq.isDesktop()) {
				scrollToElementId(elem)
			}else {
				this.selectedCategory = elem
			}
		}
	},

	mounted () {
		var currentPosition = 0
		this.$nextTick(() => {
			window.addEventListener('scroll', () => {
				var scrollDown = () => window.scrollY > currentPosition && window.scrollY > 10
				this.scrollDown = !!scrollDown()
				currentPosition = window.scrollY
			})
		})
	}
}

</script>

<style scoped>
.close {
	margin-right: 20px;
	transform: scaleX(1.1);
	color: black;
	margin-bottom: 3px;
}

.float {
	position: -webkit-sticky;
	position: sticky;
	top: 100px;
	transition: ease 0.5s all;
}

.triangle-image {
	background-image: url("../assets/img/covers/box-hands.jpeg");
	background-position: center 0;
}

.partner-bennet {
	background-image: url("https://api.quomi.it/oldimg/instacook1.webp");
	background-position: center 0;
}

.float.scrolled-down {
	top: 20px;
}

.faq-items >>> .v-expansion-panel-content {
	display: block;
	padding: 15px;
}

@media (max-width: 1024px) {
	.float.scrolled-down {
		top: 50px;
	}
}

.faq {
	position: relative;
}

.faq-categories .selected {
	color: var(--quomi-primary) !important;
	font-weight: 700;
}

.faq-category  {
	position: relative;
	display: block;
	padding: 0 28px 0 16px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	border-bottom: 1px solid var(--quomi-ligthgrey-hover);
}

.faq-category + .faq-category {
	margin-top: 30px;
}

.faq-items {
	position: fixed;
	height: 100%;
	width: 100%;
	top: 50px;
	right: 0;
	background: #ffffff;
	padding: 0 5% 1em;
	overflow: auto;
	-webkit-overflow-scrolling: touch;
	z-index: 99;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	transition: ease 0.5s all;
}

.faq-items.scrolled-down {
	top: 0;
}

.faq-group.selected {
	display: block;
}

.faq-group .faq-title {
	background: transparent;
	box-shadow: none;
	margin: 1em 0;
}

.faq-group .faq-title h2 {
	font-weight: bold;
	text-transform: uppercase;
	margin-bottom: 0;
	font-size: 15px;
	color: #575A5C;
}

/* .faq-trigger {
	cursor: pointer;
	position: relative;
	display: block;
	margin: 1.6em 0 .4em;
	line-height: 1.2;
} */

/* .faq-content p {
	font-size: 14px;
	line-height: 1.4;
	color: #575A5C;
} */

@media only screen and (min-width: 1024px) {
	/* .faq-group > .faq-content {
		background: var(--quomi-bg-light-secondary);
		margin-bottom: 6px;
		border-radius: 4px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
		-webkit-transition: box-shadow 0.2s;
		-moz-transition: box-shadow 0.2s;
		transition: box-shadow 0.2s;
	} */

	.faq-group .faq-title {
		margin: 2em 0 1em;
	}

	.faq-group:first-child .faq-title {
		margin-top: 0;
	}

	/* .faq-trigger {
		font-size: 20px;
		font-weight: 300;
		margin: 0;
		padding: 24px 72px 24px 24px;
	} */

	/* .faq-trigger::after {
		content: '\f078';
		font-family: 'FontAwesome';
	} */

/* 	.rotated::after {
		-webkit-transform: rotate(-90deg);
		-moz-transform: rotate(-90deg);
		-ms-transform: rotate(-90deg);
		-o-transform: rotate(-90deg);
		transform: rotate(-90deg) translate(-15px, -5px)
	} */

	/* .faq-trigger::before, .faq-trigger::after {
		position: absolute;
		right: 24px;
		height: 2px;
		width: 13px;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		-webkit-transition-property: -webkit-transform;
		-moz-transition-property: -moz-transform;
		transition-property: transform;
		-webkit-transition-duration: 0.2s;
		-moz-transition-duration: 0.2s;
		transition-duration: 0.2s;
	}
	.faq-trigger::before {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
		right: 32px;
	} */

	/* .faq-content {
		padding: 10px;
	}

	.faq-content p {
		line-height: 1.6;
	} */

	.faq {
		position: relative;
		box-shadow: none;
	}

	.faq-categories {
		width: 30%;
		float: left;
		border-right: 1.5px dotted #7c8083;
	}

	.faq-category {
		cursor: pointer;
		padding: 0 24px;
		-webkit-transition: background 0.2s, padding 0.2s;
		-moz-transition: background 0.2s, padding 0.2s;
		transition: background 0.2s, padding 0.2s;
		border-bottom: none;
	}

	.faq-items {
		position: static;
		height: auto;
		width: 68%;
		float: right;
		overflow: visible;
		-webkit-transform: translateZ(0) translateX(0);
		-moz-transform: translateZ(0) translateX(0);
		-ms-transform: translateZ(0) translateX(0);
		-o-transform: translateZ(0) translateX(0);
		transform: translateZ(0) translateX(0);
		padding: 0;
		background: transparent;
	}
}

@media only screen and (min-width: 1024px) {
	.faq-categories {
		width: 250px;
		z-index: 2;
	}
	.faq-categories a::before {
		display: block;
		top: 0;
		right: auto;
		left: 0;
		height: 100%;
		width: 3px;
		background-color: var(--quomi-primary-hover);
		opacity: 0;
		-webkit-transition: opacity 0.2s;
		-moz-transition: opacity 0.2s;
		transition: opacity 0.2s;
	}

	.faq-categories.is-fixed {
		/* top and left value assigned in jQuery */
		position: fixed;
	}

	.faq-items {
		float: none;
		width: 100%;
		padding-left: 300px;
		padding-top: 15px;
	}

	.gift-faq-items {
		padding: 0;
		text-align: start;
	}
}
</style>
